<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-08 15:55:42
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimType\components\newClaimItem.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-07-05 14:22:19
-->
<template>
  <normalDialog
    :title="$t('label_essweb_claimType_form_dialog_cliamItemTitle')"
    :dialog="show"
    @close="closeDialog"
    width="800"
    maxWidth="800"
    scrollable
  >
    <template v-slot:content>
      <Tabler
        :headers="headers"
        :avPerPage="50"
        :height="500"
        :showFooter="false"
        :defaultSelect="PorpertyData"
        @select="(sel) => (selected = sel)"
        :items="desserts"
        itemKey="uuid"
        :showSelect="showSelect"
      >
        <template v-slot:item.name="{ item }">
          {{ $getCommonLangValue(item.claim_item_type_name) }}
        </template>
      </Tabler>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="onSave" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newClaimItem",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  props: ["show", "PorpertyData"],
  data() {
    return {
      desserts: [],
      selected: [],
      showSelect: true,
      headers: [
        {
          text: "label_essweb_claimType_form_claimItemNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    PorpertyData(val) {
      this.selected = val;
    },
  },
  mounted() {
    this.getClaimItems();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    onSave: function () {
      this.$emit("onSave", this.selected);
    },
    getClaimItems: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_item_type",
        url: "/claim-item-type/get-list/",
        data: {},
      }).then((res) => {
        that.desserts = res.data;
      });
    },
  },
};
</script>
